import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translation from './translations.json'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translation.en,
    },
    ja: {
      translation: translation.ja,
    },
  },
  lng: document.documentElement.lang,
  fallbackLng: document.documentElement.lang,
  interpolation: {
    prefix: '%{',
    suffix: '}',
    escapeValue: false, // React 側でエスケープするため i18next の二重エスケープを無効化
  },
})

export default i18n
